var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F2F4F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#F9FAFB",
    strokeWidth: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_1565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.25 28.25C31.25 28.6478 31.092 29.0294 30.8107 29.3107C30.5294 29.592 30.1478 29.75 29.75 29.75H16.25C15.8522 29.75 15.4706 29.592 15.1893 29.3107C14.908 29.0294 14.75 28.6478 14.75 28.25V20C14.75 19.6022 14.908 19.2206 15.1893 18.9393C15.4706 18.658 15.8522 18.5 16.25 18.5H19.25L20.75 16.25H25.25L26.75 18.5H29.75C30.1478 18.5 30.5294 18.658 30.8107 18.9393C31.092 19.2206 31.25 19.6022 31.25 20V28.25Z",
    stroke: "#475467",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 26.75C24.6569 26.75 26 25.4069 26 23.75C26 22.0931 24.6569 20.75 23 20.75C21.3431 20.75 20 22.0931 20 23.75C20 25.4069 21.3431 26.75 23 26.75Z",
    stroke: "#475467",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_1565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/cameraIcon.072078f98e1258dc25bd8599564f927c.svg";
export { ForwardRef as ReactComponent };